import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useTraffic() {
  const { visible, trafficTypes } = useAppSelector((state) => state.traffic);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "10e6dc0a-27a1-4abf-9d7a-29f0ddf49456",
    IncludeNonServiceBranches: false,
    Parameters: {
      "948b17e0-7f01-11ef-8d00-1062eb32e4ff": trafficTypes,
      "1bfbddf2-2df6-433b-a735-b3faf9710c1f": date.created_after || "2020-06-03",
      "3635d4ca-94df-4851-80a8-85b80454f232": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, trafficTypes],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data.Rows, "jytsjc");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
